<template>
  <div>
    <FccTiposDadosCadastrais
      v-model="tiposDadosSelecionados"
      :items="listagemTiposDadosCadastrais"
      @adicionar="adicionarDadosCadastrais"
    />

    <FccRequisicaoDadosCadastrais
      :items="listagemRequisicaoDadosCadastrais"
      :buscaRealizada="buscaRealizada"
      @deletar="deletarDadosCadastrais"
      @importar="importarAlteracoes"
      @buscar="buscarAlteracoes"
    />

    <FccHistoricoImportacoesPorRequisicoes :items="historicoImportacoesPorRequisicoes" />
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import FccTiposDadosCadastrais from './fccTiposDadosCadastrais.vue'
import FccRequisicaoDadosCadastrais from './fccRequisicaoDadosCadastrais.vue'
import FccHistoricoImportacoesPorRequisicoes from './fccHistoricoImportacoesPorRequisicoes.vue'

export default {
  components: {
    FccTiposDadosCadastrais,
    FccRequisicaoDadosCadastrais,
    FccHistoricoImportacoesPorRequisicoes
  },
  props: {
    controlePage: Object
  },
  data() {
    return {
      baseUrlPublicacao: '',
      listagemTiposDadosCadastrais: [],
      listagemRequisicaoDadosCadastrais: [],
      tiposDadosSelecionados: [],
      historicoImportacoesPorRequisicoes: [],
      buscaRealizada: false
    }
  },
  computed: {
    spi() {
      return this.controlePage.spi
    },
    cdFuncionario() {
      return this.dadosUserSession.usuCdFuncionario
    }
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.buscarTiposDadosCadastrais()
    this.buscarRequisicaoDadosCadastrais()
    this.buscarHistoricoDeMudancas()
    this.verificaBusca()
  },
  methods: {
    buscarTiposDadosCadastrais() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          `${this.baseUrlPublicacao}PublicacaoCorrecaoCadastral/TipoDadosCadastrais`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemTiposDadosCadastrais = response.data
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    buscarRequisicaoDadosCadastrais() {
      this.carregaTexto(this.codeMensagem('C01'))

      axios
        .get(
          `${this.baseUrlPublicacao}PublicacaoCorrecaoCadastral/ListaRequisicaoDadosCadastrais/${this.spi}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemRequisicaoDadosCadastrais = response.data
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    buscarHistoricoDeMudancas() {
      this.carregaTexto(this.codeMensagem('C01'))

      axios
        .get(
          `${this.baseUrlPublicacao}PublicacaoCorrecaoCadastral/ListaRequisicaoDadosCadastraisDeletados/${this.spi}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.historicoImportacoesPorRequisicoes = response.data
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    verificaBusca() {
      this.carregaTexto(this.codeMensagem('C01'))

      axios
        .get(
          `${this.baseUrlPublicacao}PublicacaoCorrecaoCadastral/VerificaBusca/${this.spi}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.buscaRealizada = response.data
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    adicionarDadosCadastrais(dados) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          `${this.baseUrlPublicacao}PublicacaoCorrecaoCadastral/AdicionarRequisicaoDadosCadastrais`,
          {
            cdFuncionario: this.cdFuncionario,
            spi: this.spi,
            idTiposDadosCadastrais: dados
          },
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.buscarRequisicaoDadosCadastrais()
          this.verificaBusca()
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    deletarDadosCadastrais() {
      this.callConfirm(this.mensagemExcluir, 'todos os tipos de dados cadastrais?').then(
        (result) => {
          if (result.value) {
            this.carregaTexto(this.codeMensagem('C01'))
            axios
              .delete(
                `${this.baseUrlPublicacao}PublicacaoCorrecaoCadastral/DeletarRequisicaoDadosCadastrais/${this.spi}/${this.cdFuncionario}`,
                this.dadosLoginSession.fccTokenHeaders
              )
              .then(() => {
                this.callToast(this.mensagensUpdate.excluido, 'success')

                this.buscarHistoricoDeMudancas()
                this.buscarRequisicaoDadosCadastrais()

                this.carregaTexto()
              })
              .catch(this.setErrorSystem)
          }
        }
      )
    },
    buscarAlteracoes() {
      this.callConfirm('Deseja buscar as alterações dos dados?', '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          axios
            .post(
              `${this.baseUrlPublicacao}PublicacaoCorrecaoCadastral/ExecutaRequisicaoCampos`,
              `'${this.spi}'`,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.callToast('Alterações buscadas', 'success')
              this.buscarRequisicaoDadosCadastrais()
              this.carregaTexto()
              this.verificaBusca()
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    importarAlteracoes() {
      this.callConfirm('Deseja importar as alterações?', '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          axios
            .post(
              `${this.baseUrlPublicacao}PublicacaoCorrecaoCadastral/ImportacaoDadosCadastrais`,
              {
                cdFuncionario: this.cdFuncionario,
                spi: this.spi
              },
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.callToast('Alterações importadas', 'success')

              this.buscarHistoricoDeMudancas()
              this.buscarRequisicaoDadosCadastrais()

              this.carregaTexto()
            })
            .catch(this.setErrorSystem)
        }
      })
    }
  }
}
</script>
